export default __webpack_public_path__ + "static/media/img2.81a2f4d2.PNG";